export const ORDERS = {
    BASE_URL: "/api/commerce/orders",
    SEARCH: "/api/commerce/orders/search",
    REORDER: "/api/commerce/orders/reorder"
};

export const INVOICES = {
    BASE_URL: "/api/commerice/invoice",
    INVOICE_SEARCH: "/api/commerce/orders/invoice/request"
};

export const AUTH = {
    LOGIN: "/api/commerce/login",
    LOGINXDB: "/mvcapi/apianalytics/login",
    LOGOUT: "/api/commerce/logout",
    LOGOUTXDB: "/mvcapi/apianalytics/logout",
    REGISTER: "/api/commerce/register",
    FORGOT: "/api/commerce/password/forgot",
    RESEND_VERIFICATION: "/api/commerce/resendemailverification",
    RESET_PASSWORD: "/api/commerce/password/reset"
};

export const SETTINGS = {
    BASE_URL: "/api/commerce/settings",
    TRANSLATE: "/api/translate",
    SWITCH_SOLD_TO: "/api/commerce/switchSoldTo",
    UPDATE_PPP: "/api/commerce/updatePPP"
};

export const EMAILS = {
    BASE_URL: "/api/commerce/addresses/emails"
};

export const FAVORITES = {
    BASE_URL: "/api/commerce/favorites"
};

export const COMM_PREFS = {
    BASE_URL: "/api/commerce/customer/communicationpreferences"
};

export const ADDRESSES = {
    BASE_URL: "/api/commerce/addresses",
    SET_DEFAULT: "/api/commerce/addresses/setdefault",
    MAILING_ADDRESS_UPDATE: "/api/commerce/addresses/mailingaddress"
};

export const PROFILE = {
    CUSTOMER: {
        BASE_URL: "/api/commerce/customer",
        ACCOUNT_INFO: "/api/commerce/customer/accountinfo"
    },
    NEW_USERNAME: "/api/commerce/customer/username",
    CHANGE_PASSWORD: "/api/commerce/password"
};

export const PAYMENT_METHODS = {
    BASE_URL: "/api/commerce/paymentMethods",
    CREDIT_CARD: "/api/commerce/paymentMethods/cc",
    CREDIT_CARD_FRAME: "/commerce/account/addcard",
    PURCHASE_ORDER: "/api/commerce/paymentMethods/po",
    INTERNAL: "/api/commerce/paymentMethods/internal",
    SET_DEFAULT: {
        CREDIT_CARD: "/api/commerce/paymentMethods/cc/setdefault",
        PURCHASE_ORDER: "/api/commerce/paymentMethods/po/setdefault",
        INTERNAL: " /api/commerce/paymentMethods/internal/setdefault"
    }
};

export const HELIX_PASSES = {
    BASE_URL: "/api/commerce/helix",
    SITE_SEARCH: "/api/commerce/helix/sites/search",
    PASSES: "/api/commerce/helix/passes",
    PASSES_LITE: "/api/commerce/helix/passes/noproduct",
    UPDATE: "/api/commerce/helix/passes/update",
    INSTITUTES: "/api/commerce/helix/partnership/institutes",
    EPEX_CART: "/api/commerce/helix/updateepexcart",
    GET_CART: "/api/commerce/helix/getepexcart",
    HELIX_UNLOCK: "/api/commerce/helix/passes/units/unlock"
}

export const HELIX_PRODUCTS = {
    BASE_URL: "/api/commerce/helix/passes/products/"
}

export const ADD_TO_HELIX = {
    BASE_URL: "/api/commerce/helix/passes/products/available/search/",
    PASSES_NO_PROD: "/api/commerce/helix/passes/noproduct",
    REQUEST_PRODUCT: "/api/commerce/helix/addtohelix"
}

export const PPP_PENDING_ORDERS = {
    BASE_URL: "/api/commerce/orders/ppp/pending"
}

export const PPP_ORDER_DETAILS = {
    BASE_URL: "/api/commerce/orders/ppp"
}

export const PPP_NOTIFICATIONS = {
    BASE_URL: "/api/commerce/notifications"
};

export const PPP_ORDER_HISTORY = {
    ORDER_SEARCH: "/api/commerce/orders/ppp/ordersearch"
}

export const ACCOUNT_HEALTH = {
    BASE_URL: "/api/commerce/accountHealth"
};

